<template>
    <div v-if="showPrompt" class="fixed bottom-4 right-4 z-50 max-w-xs rounded-lg bg-black px-4 py-3 text-white shadow-lg">
        <div class="text-xs leading-5">
            {{ audioBlocked ? $t('general.audio_announcements_blocked') : $t('general.audio_announcements_disabled') }}
        </div>
        <button @click="enableAudio" class="mt-3 w-full rounded-md bg-white px-3 py-2 text-xs font-semibold text-black">
            {{ $t('general.turn_on_sound') }}
        </button>
    </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
    computed: {
        ...mapGetters({
            audioEnabled: 'getAudioEnabled',
            audioBlocked: 'getAudioBlocked',
            audioQueue: 'getAudioQueue',
            activeAnnouncement: 'getActiveAnnouncement',
        }),
        showPrompt() {
            return this.audioBlocked || (!this.audioEnabled && (this.audioQueue.length > 0 || !!this.activeAnnouncement))
        },
    },
    methods: {
        async enableAudio() {
            await this.$store.dispatch('enableAudio')
        },
    },
}
</script>
